
import { Component, Vue } from 'vue-property-decorator'
import InputPasswordBase from '@/components/atoms/InputPasswordBase.vue'

/**
 * パスワード入力欄
 */
@Component({
  components: {
    InputPasswordBase,
  },
})
export default class InputPassword extends Vue {
  /**
   * 入力時のイベント
   *
   * @param value 入力値
   */
  private inputEvent(value: string): void {
    this.$emit('input', value)
  }
}
